/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type TagProject_viewer$ref = any;
export type TagProjectModal_viewer$ref = any;
export type TagProjectModal_viewer = {
    readonly " $fragmentRefs": TagProject_viewer$ref;
    readonly " $refType": TagProjectModal_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "TagProjectModal_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TagProject_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'c4ca8350b02842b4ff7a0de1523d9e7e';
export default node;
